import { render, staticRenderFns } from "./MessagesGroup.vue?vue&type=template&id=633c9cfe&scoped=true&"
import script from "./MessagesGroup.vue?vue&type=script&lang=js&"
export * from "./MessagesGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessagesGroup.vue?vue&type=style&index=0&id=633c9cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c9cfe",
  null
  
)

export default component.exports